import {
  DomUtil,
  Feature,
  DataQuery,
  LineSegment,
  PointGeometry,
  DataTableLocal as DataTable,
  RGBA
} from "cartovista";
import FindRoutesResultsList from "./FindRoutesResultsList";
import MapTarget from "../../mapTools/MapTarget";
import { findRoutes} from "../../utils/ServerRequests";
import { createFeatures,  createDataRows, createDataColumns } from "../../utils/CvUtils";
import {show} from "../../appTools/Alerts";
import { Popover } from 'bootstrap';
import "../../../css/FindRoutes.css";﻿

const responsiveBtn = '<span id="cv-responsiveBtnFindRoutesView"></span>';
const responsiveViewContainer = '<div id="cv-responsiveFindRoutesView" class="cv-responsiveViewContainer"></div>';
const genericView = '<div data-cv-role="genericView" id="FindRoutes_panel" data-cv-active="false" data-cv-responsivetarget="cv-responsiveFindRoutesView"></div>';
const btnToggleGenericView = '<button data-cv-role="btnToggleGenericView" id="FindRoutes_panel_btn" data-cv-togglegroup="topSidebarGroup" data-cv-associatedcontainer="FindRoutes_panel" data-cv-responsivetarget="cv-responsiveBtnFindRoutesView" title="Itinéraire: générer un itinéraire à partir du réseau routier"></button>';

    const startTypePopoverHtml = '<p>Le paramètre <strong><em>Départ</em></strong> spécifie la source à partir de laquelle l\'itinéraire est calculé. Deux options sont disponibles:' +
                                        '<ul style=\'margin-left:20px;\'>' +
                                            '<li><strong><em>Point dans la carte</em></strong>: utilisez l\'outil de cible pour pointer une source directement sur la carte. Cliquez sur le bouton cible, puis cliquez sur la carte à l\'emplacement voulu.</li>' +
                                            '<li><strong><em>Entité sélectionnée</em></strong>: utilisez l\'entité ponctuelle (point) sélectionnée comme source. Vous devez au préalable utiliser les outils de sélections disponibles dans la barre d\'outils de la carte.</li>' +
                                        '</ul>' +
                                    '</p>';

    const endTypePopoverHtml = '<p>Le paramètre <strong><em>Arivée</em></strong> spécifie la source identifiant le point final de l\'itinéraire. Deux options sont disponibles:' +
                                        '<ul style=\'margin-left:20px;\'>' +
                                            '<li><strong><em>Point dans la carte</em></strong>: utilisez l\'outil de cible pour pointer une source directement sur la carte. Cliquez sur le bouton cible, puis cliquez sur la carte à l\'emplacement voulu.</li>' +
                                            '<li><strong><em>Entité sélectionnée</em></strong>: utilisez l\'entité ponctuelle (point) sélectionnée comme source. Vous devez au préalable utiliser les outils de sélections disponibles dans la barre d\'outils de la carte.</li>' +
                                        '</ul>' +
                                    '</p>';

    const travelModeInputPopoverHtml = '<p>Le paramètre <strong><em>Mode de transport</em></strong> spécifie le moyen utilisé afin de se déplacer.  Une voiture se doit de respecter les routes à sens unique, alors qu\'un piéton n\'est pas obligé de le faire.</p>';

    const findRoutesContainerHtml = '<div id="FindRoutes_container">' +
                                            '<ul class="nav nav-tabs" role="tablist">' +
                                                '<li class="nav-item" role="presentation"><a class="nav-link active" href="#FindRoutes_requestTab" aria-controls="FindRoutes_requestTab" role="tab" data-bs-toggle="tab">Requête</a></li>' +
                                                '<li class="nav-item" role="presentation"><a class="nav-link" href="#FindRoutes_resultsTab" aria-controls="FindRoutes_resultsTab" role="tab" data-bs-toggle="tab">Résultats&nbsp;<span id="FindRoutes_resultsCount"></span></a></li>' +
                                            '</ul>' +
                                            '<div class="tab-content">' +
                                                '<div role="tabpanel" class="tab-pane active" id="FindRoutes_requestTab">' +
                                                        '<h5>' +
                                                            '<strong>Création d\'un itinéraire</strong>' +
                                                            '<br><small><em>Veuillez paramétrer votre requête en utilisant le formulaire ci-dessous, puis cliquez sur Soumettre.</em></small>' +
                                                        '</h5>' +
                                                        '<form id="FindRoutes_form" role="form">' +
                                                            '<div class="form-group">' +
                                                                '<label for="FindRoutes_startTypeInput" class="form-label"><span style="font-family:CartoVistaCartographic;color:#e98316;">)</span> Départ</label>&nbsp;(<a href="javascript:void(0)" data-bs-toggle="popover" data-bs-title="Aide : Point de départ" data-bs-trigger="focus" data-bs-container="body" data-bs-html="true" data-bs-content="' + startTypePopoverHtml + '">?</a>)' +
                                                                '<div style="display:inline-table; width:100%;">' +
                                                                    '<select id="FindRoutes_startTypeInput" class="form-select form-control" style="display:table-cell;">' +
                                                                        '<option value="MAP_TARGET">Point dans la carte</option>' +
                                                                        '<option value="SELECTION">Entité sélectionnée</option>' +
                                                                    '</select>' +
                                                                    '<div style="display:table-cell; width:0; vertical-align:top;">' +
                                                                        '<a id="FindRoutes_startMapTargetBtn" class="btn btn-primary" href="javascript:void(0)" data-cv-radioGroup="mapTools" type="button" tabindex="-1" title="Cible: Définir le point de départ en pointant un emplacement sur la carte"></a>' +
                                                                    '</div>' +
                                                                '</div>' +
                                                            '</div>' +
                                                            '<div class="form-group">' +
                                                                '<label for="FindRoutes_endTypeInput" class="form-label"><span style="font-family:CartoVistaCartographic;color:#32cda4;">)</span> Arrivée</label>&nbsp;(<a href="javascript:void(0)" data-bs-toggle="popover" data-bs-title="Aide : Arrivée" data-bs-trigger="focus" data-bs-container="body" data-bs-html="true" data-bs-content="' + endTypePopoverHtml + '">?</a>)' +
                                                                '<div style="display:inline-table; width:100%;">' +
                                                                    '<select id="FindRoutes_endTypeInput" class="form-select form-control" style="display:table-cell;">' +
                                                                        '<option value="MAP_TARGET">Point dans la carte</option>' +
                                                                        '<option value="SELECTION">Entité sélectionnée</option>' +
                                                                    '</select>' +
                                                                    '<div style="display:table-cell; width:0; vertical-align:top;">' +
                                                                        '<a id="FindRoutes_endMapTargetBtn" class="btn btn-primary" href="javascript:void(0)" data-cv-radioGroup="mapTools" type="button" tabindex="-1" title="Cible: Définir le point d\'arrivée en pointant un emplacement sur la carte"></a>' +
                                                                    '</div>' +
                                                                '</div>' +
                                                            '</div>' +
                                                            '<div class="form-group">' +
                                                                '<label for="FindRoutes_travelModeInput" class="form-label">Mode de transport</label>&nbsp;(<a href="javascript:void(0)" data-bs-toggle="popover" data-bs-title="Aide : Mode de transport" data-bs-trigger="focus" data-bs-container="body" data-bs-html="true" data-bs-content="' + travelModeInputPopoverHtml + '">?</a>)' +
                                                                '<select id="FindRoutes_travelModeInput" class="form-select form-control">' +
                                                                    '<option value="WALK">Piéton</option>' +
                                                                    '<option value="CAR" selected>Voiture</option>' +
                                                                '</select>' +
                                                            '</div>' +
                                                            '<div class="d-grid justify-content-md-end">' +
                                                              '<button type="submit" id="FindRoutes_submitBtn" class="btn btn-primary">Soumettre</button>' +
                                                            '</div>' +
                                                        '</form>' +
                                                '</div>' +
                                                '<div id="FindRoutes_resultsTab" role="tabpanel" class="tab-pane">' +
                                                        '<div id="FindRoutes_layersListContainer"></div>' +
                                                '</div>' +
                                            '</div>' +
                                        '</div>';

    export default class FindRoutes {
      constructor() {
        $(".cv-responsiveBottomBar").append(responsiveBtn);
        $(".cv-left-top-pane").append(responsiveViewContainer);
        $(".cv-right-top-pane").append(genericView);
        $(".cv-alignBottom").before(btnToggleGenericView);
        window.cartovista.addOneTimeEventListener(cartovista.EVENTS.MAP_LOADED + "_" + C.MAP.ID, this._onCartoVistaMapLoaded, this);
        window.cartovista.addOneTimeEventListener(C.LAYERS.FIND_ROUTES.LAYER_ID + "_layerCreated", this._onFindRoutesLayerCreated, this);
        window.cartovista.addOneTimeEventListener(C.LAYERS.FIND_ROUTES_STOPS.LAYER_ID + "_layerCreated", this._onFindRoutesStopsLayerCreated, this);

        this._$container = $(findRoutesContainerHtml);
        _.forEach(this._$container.find('[data-bs-toggle="popover"]'), function(popover){
          new Popover(popover, {
            placement: function() { return DomUtil.isResponsiveUI() ? "right" : "left"; }
          });
        });
        this._$resultsCountContainer = this._$container.find("#FindRoutes_resultsCount");
        this._$form = this._$container.find("#FindRoutes_form");
        this._formIsSubmitting = false;
        this._$startTypeInput = this._$form.find("#FindRoutes_startTypeInput");
        this._$endTypeInput = this._$form.find("#FindRoutes_endTypeInput");
        this._startType = this._$startTypeInput.val();
        this._endType = this._$endTypeInput.val();
        this._$startMapTargetBtn = this._$form.find("#FindRoutes_startMapTargetBtn");
        this._$endMapTargetBtn = this._$form.find("#FindRoutes_endMapTargetBtn");
        this._$travelModeInput = this._$form.find("#FindRoutes_travelModeInput");
        this._$submitBtn = this._$form.find("#FindRoutes_submitBtn");
        this._$form.submit(this._onFormSubmitted.bind(this));
        this._$startTypeInput.change(this._onStartTypeInputChanged.bind(this));
        this._$endTypeInput.change(this._onEndTypeInputChanged.bind(this));
      }

      _onCartoVistaMapLoaded(evt) {
        this._map = window.cartovista.externalInterface.map;
        this._mapController = window.cartovista.getMapController(this._map);
        $("#FindRoutes_panel_btn").html('<span class="cv-icon"><i class="bi bi-sign-turn-right-fill"></i></span>');
        $("#FindRoutes_panel").html(this._$container);
        this._startMapTarget = new MapTarget(this._$startMapTargetBtn[0], C.PANELS.FIND_ROUTES.START_MAP_TARGET_DECORATION_STYLE, false);
        this._endMapTarget = new MapTarget(this._$endMapTargetBtn[0], C.PANELS.FIND_ROUTES.END_MAP_TARGET_DECORATION_STYLE, false);
        this._findRoutesController = window.cartovista.getUIController(this._map).findInstance("FindRoutes_panel")
        this._findRoutesController.addEventListener(this._findRoutesController.EVENTS.ACTIVATED, this._onPanelActivated, this);
        this._findRoutesController.addEventListener(this._findRoutesController.EVENTS.DEACTIVATED, this._onPanelDeactivated, this);
        window.cartovista.resizeRightVerticalSplitter(325);        
    };

    _onFindRoutesLayerCreated(evt) {
        this._findRoutesLayer = this._map.getLayer(C.LAYERS.FIND_ROUTES.LAYER_ID);
        this._findRoutesDataTable = this._findRoutesLayer.getDataTable(C.LAYERS.FIND_ROUTES.DATATABLE_ID);
        this._findRoutesDirectionsDataTable = new DataTable("FIND_ROUTES_DIRECTIONS");
        var dataColumns = createDataColumns(C.LAYERS.FIND_ROUTES);
        this._findRoutesDirectionsDataTable.addDataColumns(dataColumns);
        this._findRoutesLayer.dataElementRoot.addDataElement(this._findRoutesDirectionsDataTable);
        this._resultsList = new FindRoutesResultsList(this._$container.find("#FindRoutes_layersListContainer"), this._findRoutesLayer, this._findRoutesDataTable, true);
        this._resultsList.addEventListener("ResultsList_resultAdded", this._onResulListCountChanged, this);
        this._resultsList.addEventListener("ResultsList_resultRemoved", this._onResulListCountChanged, this);
    }

    _onFindRoutesStopsLayerCreated(evt) {
        this._stopsLayer = this._map.getLayer(C.LAYERS.FIND_ROUTES_STOPS.LAYER_ID);
        this._resultsList.stopsLayer = this._stopsLayer;
        this._resultsList.stopsDataTable = this._stopsLayer.getDataTable(C.LAYERS.FIND_ROUTES_STOPS.DATATABLE_ID);
        this._resultsList.directionsDataTable = this._findRoutesDirectionsDataTable;
    }

    _onPanelActivated(e) {
          if(this._startType != "MAP_TARGET"){
              this._$startTypeInput.val("MAP_TARGET");
              this._$startTypeInput.change();
          }
          if(this._endType != "MAP_TARGET"){
              this._$endTypeInput.val("MAP_TARGET");
              this._$endTypeInput.change();
          }
          this._startMapTarget._toggleMapTargetVisibility(true);
          this._endMapTarget._toggleMapTargetVisibility(true);
    };

    _onPanelDeactivated(e) {
          this._startMapTarget._toggleMapTargetVisibility(false);
          this._endMapTarget._toggleMapTargetVisibility(false);
          _.find(window.cartovista.getUIController(this._map).cvToggleGroup._toggleGroups.mapTools.members, { '_element': $(".cv-infoPanTool")[0]}).toggleOn();
    };

    _onStartTypeInputChanged(e) {
        this._startType = this._$startTypeInput.val();
        if (this._startType != "MAP_TARGET") {
          this._$startMapTargetBtn.parent().css("display", "none");
        this._startMapTarget.toggleOff();
        } else if(this._startType == "MAP_TARGET"){
          this._$startMapTargetBtn.parent().css("display", "table-cell");
        }
        this._startMapTarget._toggleMapTargetVisibility((this._startType == "MAP_TARGET"));
    };

    _onEndTypeInputChanged(e) {
        this._endType = this._$endTypeInput.val();
        this._$endMapTargetBtn.parent().toggle();
        this._endMapTarget.toggleOff();
        this._endMapTarget._toggleMapTargetVisibility((this._endType == "MAP_TARGET"));
    };

    _onFormSubmitted(e) {
        e.preventDefault();
        if (!this._formIsSubmitting) {
            this._map.selectionLayer.computeSelectionStack(function(linkingIds){
                if(this._startType == "SELECTION" && this._endType == "SELECTION" && (this._map.selectionLayer.layerType != "POINT" || linkingIds.length != 2)){
                    show("FindRoutes_noPointFeaturesSelected");
                } else if(this._startType == "MAP_TARGET" && !this._startMapTarget._decoration._created){
                    show("FindRoutes_startMapTargetNotCreated");
                } else if(this._endType == "MAP_TARGET" && !this._endMapTarget._decoration._created){
                    show("FindRoutes_endMapTargetNotCreated");
                } else if(((this._startType == "SELECTION" && this._endType == "MAP_TARGET") || (this._startType == "MAP_TARGET" && this._endType == "SELECTION")) && (this._map.selectionLayer.layerType != "POINT" || linkingIds.length != 1)){
                    show("FindRoutes_needOnePointFeatureSelected");
                } else{
                    this._makeFindRoutesRequest();
                }
            }.bind(this));
        } else {
            show("FindRoutes_formIsSubmitting");
        }
    };

    _makeFindRoutesRequest() {
        var facilitiesData = this._getFacilitiesData();
        this._startMapTarget._decoration.setPosition(facilitiesData.features[0].geometry.x, facilitiesData.features[0].geometry.y);
        this._endMapTarget._decoration.setPosition(facilitiesData.features[1].geometry.x, facilitiesData.features[1].geometry.y);
        this._startMapTarget._decoration._created = true;
        this._endMapTarget._decoration._created = true;
        this._startMapTarget._toggleMapTargetVisibility(true);
        this._endMapTarget._toggleMapTargetVisibility(true);

        var travelMode = this._$travelModeInput.find("option:selected").val();
        show("FindRoutes_requestSubmitted");
        this._formIsSubmitting = true;
        findRoutes(facilitiesData, travelMode)
            .then(this._onRequestSuccess.bind(this))
            .catch(this._onRequestError.bind(this));
    };

    _getFacilitiesData() {
        var featureStart = (this._startType === "SELECTION") ? this._getSelectedFeaturesData() : this._getMapTargetFeaturesData(this._startMapTarget, "Départ");
        var featureEnd = (this._endType === "SELECTION") ? this._getSelectedFeaturesData() : this._getMapTargetFeaturesData(this._endMapTarget, "Arrivée");
        var features = (this._startType === "SELECTION" && this._endType === "SELECTION") ? featureStart : _.concat(featureStart, featureEnd);
        var esriJson = {
            "geometryType" : "esriGeometryPoint",
            "spatialReference" : {"wkid" : 3857},
            "fields" : [
                {
                    "name" : "Name",
                    "type" : "esriFieldTypeString"
                }
            ],
            "features" : features
        };
        //arcpy.FindRoutes 10.6.1 doit avoir la length du field Name sinon bug
        esriJson["fields"][0]["length"] = _.maxBy(esriJson["features"], "attributes.Name.length")["attributes"]["Name"].length;
        return esriJson;
    };

    _getSelectedFeaturesData() {
        var featuresData;
        this._map.selectionLayer.computeSelectionStack(function(linkingIds){
            new DataQuery([this._map.selectionLayer.featureNameDataColumn], linkingIds)
                .execute(function(queryResult) {
                    this._map.selectionLayer.getSimpleFeatures(linkingIds, function(result) {
                        featuresData = _.map(result.features, function(feature, idx) {
                            return {
                                "attributes" : {
                                    "Name" : queryResult.values[this._map.selectionLayer.featureNameDataColumn.dataTable.id][this._map.selectionLayer.featureNameDataColumn.id][idx]
                                },
                                "geometry" : {
                                    "x" : feature.currentGeometry.coordinates[0][0].coordinates[0],
                                    "y" : feature.currentGeometry.coordinates[0][0].coordinates[1]
                                }
                            };
                        }.bind(this));
                    }, this);
                }, this);
        }.bind(this));

        return featuresData;
    };

    _getMapTargetFeaturesData(MapTarget, nom) {
        return [{
            "attributes" : {
                "Name" : nom
            },
            "geometry" : {
                "x" : MapTarget._decoration.geometry.coordinates[0][0].coordinates[0],
                "y" : MapTarget._decoration.geometry.coordinates[0][0].coordinates[1]
            }
        }];
    };

    _onRequestSuccess(response) {
        show("FindRoutes_serviceSuccess");
        this._formIsSubmitting = false;
        this._createResultFeatures(response);
        //log onFindRoutesRequested success event on piwik
        try {
            dataLayer.push({'event':'onFindRoutesRequested', 'queryResult': C.APP_NAME + " - success"});
        } catch(error) {
            //piwik blocked by an add blocker
            window.ClientErrorsLogger.logPiwikError(error);
        }
    };

    _createResultFeatures(response) {
        var layerConfig = _.cloneDeep(C.LAYERS.FIND_ROUTES);
        var randomColor = "rgba(" + _.random(0,255) + "," + _.random(0,255) + "," + _.random(0,255) + ",1)";
        layerConfig.STYLES[0].STYLE_LABEL_PROPERTIES.COLOR = randomColor;
        layerConfig.STYLES[0].SYMBOLIZERS[0].STROKE_COLOR = randomColor;
        var mergedFeatures = createFeatures(layerConfig, response.mergedFeatures);
        this._findRoutesLayer.addFeatures(mergedFeatures);
        this._findRoutesDataTable.addDataRows(createDataRows(C.LAYERS.FIND_ROUTES, response.mergedFeatures, _.map(mergedFeatures, "id")));
        this._mapController.zoomOnFeatures(mergedFeatures, this._findRoutesLayer, null, false);

        var layerConfigStops = _.cloneDeep(C.LAYERS.FIND_ROUTES_STOPS);
        delete layerConfigStops.LAYER_PROPERTIES.STYLE_DATACOLUMN;
        layerConfigStops.STYLES = [C.LAYERS.FIND_ROUTES_STOPS.STYLES[0]];
        var features = _.compact(_.flatten(_.map(response.features, function(feature){
          if (feature.geometry.length != 2) return createFeatures(C.LAYERS.FIND_ROUTES, [feature]);
          else return createFeatures(layerConfigStops, [feature]);
        })));
        createDataRows(C.LAYERS.FIND_ROUTES, response.features, _.map(features, "id"));
        this._findRoutesDirectionsDataTable.addDataRows(createDataRows(C.LAYERS.FIND_ROUTES, response.features, _.map(features, "id")));

        var stops = createFeatures(C.LAYERS.FIND_ROUTES_STOPS, response.stops);
        this._stopsLayer.addFeatures(stops);
        var dataTable = this._stopsLayer.getDataTable(C.LAYERS.FIND_ROUTES_STOPS.DATATABLE_ID);
        dataTable.addDataRows(createDataRows(C.LAYERS.FIND_ROUTES_STOPS, response.stops, _.map(stops, "id")));

        this._resultsList.addResult(mergedFeatures, null, features, stops);
    };

    _onRequestError(error) {
      console.error(error);
        show("FindRoutes_serviceError", {"error" : error});
        this._formIsSubmitting = false;
        //log onFindRoutesRequested error event on piwik
        try {
            dataLayer.push({'event':'onFindRoutesRequested', 'queryResult': C.APP_NAME + " - error"});
        } catch(error) {
            //piwik blocked by an add blocker
            window.ClientErrorsLogger.logPiwikError(error);
        }
    };

    _onResulListCountChanged(evt) {
        this._$resultsCountContainer.html(this._resultsList.count ? "(" + this._resultsList.count + ")" : "");
    };

}
